export function sumPrices(prices: { price: number }[]): number {
  if (!prices || prices.length <= 0) {
    return 0;
  }
  return prices.reduce((total, price) => total + (price.price || 0), 0);
}
